import { initAddToCartSuccessModalFocus, initCalendarSheets } from './scripts/calendar.js'
import { scrollToElement } from './scripts/scroll-to-element'

initAddToCartSuccessModalFocus()
const typeSelect = document.querySelector('[data-js-freeticket-type-url]')
const loadingSpinnerFullpage = document.querySelector('[data-js-loading-spinner-fullpage]')
const calendarSection = document.querySelector('[data-js-first-scroll-to]')
const calendarElement = document.querySelector('[data-js-replace-calendar-content]')
const hint = document.querySelector('[data-js-type-alert]')
const calendarAlert = document.querySelector('[data-js-calendar-alert]')
const replaceContent = document.querySelector('[data-js-replace-content]')
const accordions = document.querySelectorAll('[data-js-accordion-details]')

typeSelect.addEventListener('change', function () {
  const type = typeSelect.value
  const url = typeSelect.dataset.jsFreeticketTypeUrl + '?type=' + type
  const focusBefore = document.activeElement
  loadingSpinnerFullpage.removeAttribute('hidden')
  loadingSpinnerFullpage.focus()
  replaceContent.setAttribute('hidden', 'hidden')
  calendarAlert.removeAttribute('hidden')

  if (type === '') {
    loadingSpinnerFullpage.setAttribute('hidden', 'hidden')
    focusBefore.focus()
    calendarElement.setAttribute('hidden', 'hidden')
    hint.removeAttribute('hidden')
    accordions.forEach((accordion) => {
      accordion.removeAttribute('hidden')
    })
  } else {
    fetch(url)
      .then(response => response.json())
      .then(function (data) {
        calendarElement.innerHTML = data.html
        calendarElement.removeAttribute('hidden')
        hint.setAttribute('hidden', 'hidden')

        accordions.forEach((accordion) => {
          if (accordion.id.endsWith(type)) {
            accordion.removeAttribute('hidden')
          } else {
            accordion.setAttribute('hidden', 'hidden')
          }
        })

        initCalendarSheets()
      })
      .catch(function (data) {
        // @todo add error handling
        console.log('error')
        console.log(data)
      })
      .finally(function () {
        scrollToElement(calendarSection, 300)
        loadingSpinnerFullpage.setAttribute('hidden', 'hidden')
        focusBefore.focus()
      })
  }
})

document.addEventListener('calendarEntryLoaded', function () {
  const event = new Event('initializeValidation')
  document.dispatchEvent(event)

  const addToCartButton = document.querySelector('[data-js-add-to-cart]')
  addToCartButton.addEventListener('click', function (event) {
    const validateEvent = new Event('validateAndShowErrors')
    validateEvent.form = addToCartButton.closest('form')
    document.dispatchEvent(validateEvent)
  })
})

document.addEventListener('resetAmountInputs', function () {
  replaceContent.querySelector('#freeticket_cart_guests').value = 1
  replaceContent.querySelector('#freeticket_cart_email').value = ''
})
